var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _rect3, _rect4, _path6, _path7, _path8, _ellipse, _rect5, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2773 14.182C18.2773 12.8474 19.3638 11.7598 20.7111 11.7598H43.0308C44.3781 11.7598 45.4646 12.8474 45.4646 14.182V53.5373C45.4646 54.8719 44.3781 55.9595 43.0308 55.9595H20.7111C19.3638 55.9595 18.2773 54.8719 18.2773 53.5373V14.182Z",
    fill: "#E6EFFC",
    stroke: "#353C3F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2773 53.3223C17.2773 55.5314 19.0682 57.3223 21.2773 57.3223H42.4646C44.6737 57.3223 46.4646 55.5314 46.4646 53.3223V50.4378H17.2773V53.3223Z",
    fill: "#353C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2773 14.7266C17.2773 12.5174 19.0682 10.7266 21.2773 10.7266H42.4646C44.6737 10.7266 46.4646 12.5174 46.4646 14.7266V17.6111H17.2773V14.7266Z",
    fill: "#353C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3553 35.4482C38.6188 35.4482 38.8324 35.6799 38.8324 35.9658V40.1059C38.8324 40.849 38.2771 41.4515 37.592 41.4515H36.8286C36.5652 41.4515 36.3516 41.2198 36.3516 40.9339C36.3516 40.6481 36.5652 40.4164 36.8286 40.4164H37.592C37.7501 40.4164 37.8782 40.2774 37.8782 40.1059V35.9658C37.8782 35.6799 38.0918 35.4482 38.3553 35.4482Z",
    fill: "#6BD3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4297,
    y: 28.5107,
    width: 10.6867,
    height: 16.5606,
    rx: 3,
    fill: "#6BD3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1133 31.8223H37.785C38.8895 31.8223 39.785 32.7177 39.785 33.8223V34.7905C39.785 35.895 38.8895 36.7905 37.785 36.7905H37.1133V31.8223Z",
    fill: "#6BD3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2812,
    y: 42.583,
    width: 12.9768,
    height: 2.48409,
    rx: 1.24205,
    fill: "#6BD3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0977,
    y: 30.584,
    width: 5.34337,
    height: 2.48409,
    rx: 1,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6967 35.5049H32.0664C32.801 35.5049 33.2849 36.2704 32.9697 36.9339L32.6247 37.6604H32.9455C33.3873 37.6604 33.612 38.1914 33.3044 38.5085L31.8935 39.9631C31.5415 40.3261 30.9347 39.9968 31.0471 39.5038L31.1938 38.8608C31.2223 38.7356 31.1272 38.6163 30.9988 38.6163H30.1025C29.962 38.6163 29.8653 38.4752 29.916 38.3442L30.1309 37.7883C30.1549 37.7263 30.2075 37.6813 30.2701 37.6661C30.2627 37.5304 30.2833 37.3899 30.3367 37.2516L30.7638 36.1448C30.9126 35.7592 31.2834 35.5049 31.6967 35.5049Z",
    fill: "#26B0EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.6875 25.6653C30.9987 24.4202 32.7539 24.4202 34.0652 25.6653",
    stroke: "#26B0EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.254 23.4884C35.6965 22.9431 35.077 22.5212 34.4369 22.2125C32.7952 21.4305 30.9574 21.4305 29.3055 22.2125C28.6653 22.5212 28.0561 22.9431 27.4883 23.4884",
    stroke: "#26B0EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.8764,
    cy: 53.5155,
    rx: 2.18888,
    ry: 2.18149,
    fill: "#AEB7BC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7383,
    y: 13.666,
    width: 6.26601,
    height: 1.04434,
    rx: 0.522168,
    fill: "#6E777C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1393 32.54C45.4296 32.54 46.4755 33.586 46.4755 34.8762L46.4755 41.6219C46.6335 41.6072 46.7935 41.5998 46.9552 41.5998H52.3343C54.5434 41.5998 56.3343 43.3906 56.3343 45.5998V47.1634C56.3343 52.8428 51.7302 57.4469 46.0508 57.4469H44.3844C43.4104 57.4469 42.563 56.9053 42.1268 56.1068L35.8061 49.7862C34.9032 48.8833 34.9032 47.4194 35.8061 46.5165C36.709 45.6136 38.1729 45.6136 39.0758 46.5165L41.8032 49.2439V34.8762C41.8032 33.586 42.8491 32.54 44.1393 32.54Z",
    fill: "url(#paint0_linear_19133_206555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19133_206555",
    x1: 45.7316,
    y1: 32.54,
    x2: 45.7316,
    y2: 57.4469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB29A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.258a24ab9875c56b25e40a46803e76f9.svg";
export { ForwardRef as ReactComponent };